import { render, staticRenderFns } from "./_ConfirmRemoveModal.vue?vue&type=template&id=27f8a52d&scoped=true&"
import script from "./_ConfirmRemoveModal.vue?vue&type=script&lang=js&"
export * from "./_ConfirmRemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./_ConfirmRemoveModal.vue?vue&type=style&index=0&id=27f8a52d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f8a52d",
  null
  
)

export default component.exports